// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".end-in__container[data-v-e6ec06c8]{margin-top:-5px}.spinner[data-v-e6ec06c8]{display:inline-block;margin-left:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
